import React from "react";
export const Hand = () => (
  <svg viewBox="0 0 14 7.3">
    <path
      d="M1.3 0C.6 0 0 .6 0 1.3V6c0 .7.6 1.3 1.3 1.3S2.7 6.7 2.7 6V1.3C2.7.6 2.1 0 1.3 0zm11.4 4H7.9l-1-.3c-.2-.1-.2-.3-.2-.5.1-.2.3-.3.4-.2l.8.3h2c.4 0 .8-.3.8-.8 0-.3-.2-.6-.5-.7L5.5.1C5.4 0 5.2 0 5.1 0H4v6l4.2 1.2c.3.1.6.1.8 0l5-1.9c0-.7-.6-1.3-1.3-1.3z"
      fill="#192547"
    />
  </svg>
);
